<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <a href="/integrations/catalogue">Integrations</a> /
      <span> Failed </span>
    </nav>
    <div class="integrations-auth-success">
      <h2 class="integrations-auth-success__heading">Uh Oh! Your CRM does not support API connections.</h2>
      <div class="integrations-auth-success__group">
        <p>
          This is usually due to having a trial account or some other account limitation. Please contact your CRM
          administrator for assistance.
        </p>
        <a href="/account/crmsettings/" class="btn btn-lg btn-primary integrations-auth-success__button"
          >Go to CRM Settings</a
        >
      </div>
    </div>
    <integrations-footer></integrations-footer>
  </div>
</template>

<script>
import IntegrationsFooter from '../components/integrations/IntegrationsFooter.vue';

import {getCommercialName} from '../utility/crms/getCommercialName.js';

export default {
  name: 'integrations-auth-failed-page',
  components: {IntegrationsFooter},
  props: {
    crm: {
      type: String,
      required: true,
    },
    platformTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    crmName() {
      return getCommercialName(this.crm);
    },
  },
};
</script>

<style>
@import '../../sass/templates/integrations/_integrations.scss';
</style>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.integrations-auth-success {
  max-width: 600px;
  margin: 0 auto;
  padding: 52px 16px;
  min-height: calc(100vh - 275px);
  &__heading {
    font-size: 28px;
    color: $mine-shaft-color;
    @media (min-width: $breakpoint-sm) {
      font-size: 48px;
    }
  }
  &__img,
  &__group {
    margin: 0 auto;
  }
  &__group {
    max-width: 400px;
    display: grid;
  }
  &__button {
    font-weight: 700;
  }
}
</style>
